var i = /* @__PURE__ */ ((g) => (g.Waiting = "Waiting", g.Uploading = "Uploading", g.Uploaded = "Uploaded", g.Deleting = "Deleting", g))(i || {});
export {
  i as FileUploaderItemStateEnum
};
